const cartDefaultState = {
  oosStatus: [],
  oosItemListPayment: []
};

function cart(state = cartDefaultState, action) {
  switch (action.type) {
    case 'SET_CART_DATA':
      // return {...state, ...action.cart};
      return { ...action.cart };

    case 'REMOVE_MERGE_OOS_LIMITED_STOCK_CARD':
      const newState = { ...state };

      if (newState[action.key]) {
        newState[action.key] = { ...newState[action.key], cardToShow: action.value };
      }
      return newState;

    case 'UPDATE_CART_SUMMARY':
      return { ...state, orderSummary: action.orderSummary };
    case 'GET_CART_SUCCESS':
      return { ...state, success: action.success };

    case 'GET_CART_FAIL':
      return { ...state, success: action.success };

    case 'GET_SIZE_DETAILS_CART':
      return { ...state, sizeDetails: action.size };

    case 'GET_PRODUCT_SIZE':
      return { ...state, size: action.size };

    case 'SET_PRODUCT_OUT_OF_STOCK_IN_CART': {
      return { ...state, noStock: action.OOSItems, cardToShow: action.cardToShow };
    }

    case 'SET_CART_ERROR_CODE': {
      return { ...state, errorCode: action.errorCode };
    }
    case 'SET_CART_ERROR_OOS_PAYMENT': {
      return { ...state, oosItemListPayment: action.oosItemList };
    }
    case 'SET_CART_ERROR_DEAL_EXPIRE': {
      return { ...state, dealExpirePayment: action.dealError };
    }
    case 'SET_CART_ERROR_OOS_DEEPLINKING': {
      return { ...state, deepLinkingOosItemList: action.deepLinkingOosItemList };
    }

    case 'SET_OUT_OF_STOCK': {
      const { productId } = action;
      return {
        ...state,
        oosStatus: [...state.oosStatus, productId]
      };
    }
    case 'RESET_OUT_OF_STOCK': {
      return {
        ...state,
        oosStatus: []
      };
    }
    case 'RESET_CART_ERRORS': {
      return {
        ...state,
        errorMessages: []
      }
    }
    default:
      return state;
  }
}

export default cart;
